import { useEffect, useState } from "react";
import { Navigate, Route, BrowserRouter as Router, Routes, useNavigate } from "react-router-dom";
import CmsLayout from "../Layout/CmsLayout";
import SuperAdminLayout from "../Layout/SuperAdminLayout";
import AssetManagement from "../pages/asset-management/index";
import Channelactionscomponent from "../pages/channel-actions";
import ForgetPassword from "../pages/forgotpassword";
import Login from "../pages/Login";
import ResetPassword from "../pages/reset-password";
import Scheduling from "../pages/Scheduling";
import Monitor from "../pages/Scheduling/Monitor";
import SchedulingLoopNew from "../pages/Scheduling/scheduling-loop/scheduling-loop-new";
import Viewership from "../pages/viewership";

import CmsChannelDetail from "../pages/asset-management/channeldetail/CmsChannelDetail";
import ChannelCreation from "../pages/channel-creation/channelCreation";
import EditableGrid from "../pages/editable-grid";
import MasterSettings from "../pages/master-settings/MasterSettings";
import StoreFront from "../pages/StoreFront";
// import ViewershipComponent from './ViewershipComponent';
// import DashboardComponent from './DashboardComponent';
// import DashbordChannelComponent from './DashbordChannelComponent';
// import ChannelActionsComponent from './ChannelActionsComponent';
// import SchedulingComponent from './SchedulingComponent';
// import ChannelSetupComponent from './ChannelSetupComponent';
// import ChannelCreationComponent from './ChannelCreationComponent';
// import ChannelUploadComponent from './ChannelUploadComponent';
import GridMonitorView from "../Layout/GridMoitorViewLayout";
import AuditLogs from "../pages/audit-logs/audit-logs";
import ContactUs from "../pages/contact";
import GridMonitor from "../pages/Scheduling/GridMonitor";
import SuperTenantAdd from "../pages/tenant-onboarding/super-tenant-add";
import TenantAdd from "../pages/tenant-onboarding/tenant-add";
import TenantOnboarding from "../pages/tenant-onboarding/tenant-onboarding";
import UserManagement from "../pages/user-management";
import UserAdd from "../pages/user-management/user-add";
// import MonitorGridView from "../pages/girdMonitorView/monitoringGridView";
// import GridMoitorView from "../Layout/GridMoitorViewLayout";
import AddDistributionPlatform from "../component/AddDistributionPlatform";
import EditChannelPopup from "../component/AddDistributionPlatform/EditChannelPopup";
import ChannelSetupNew from "../component/Channel-Distribution/ChannelSetupNew/channelSetupNew";
import DistributionPlatform from "../component/Channel-Distribution/DistributionPlatform/DistributionPlatform";
import DistributionChildTable from "../component/Channel-Distribution/DistributionTable/DistributionChildTable";
import ChannelDetails from "../component/ChannelDetails/ChannelDetails";
import LinearExpandView from "../pages/Scheduling/linear-expand-view/linear-expand-view";
import SchedulingLinear from "../pages/Scheduling/scheduling-linear-new/scheduling-linear";


const PrivateRoute = ({ children }) => {
  const tenantLocalData = localStorage.getItem('tenantInfo');
  const tenantLocalDataParse = JSON.parse(tenantLocalData);
  return (tenantLocalDataParse?.identifier === "cloudtv") ?  <Navigate to="/" /> :children;
};

function AppRoutes() {
  const[superAdmin, setSuperAdmin] = useState("");
  const [identifier, setIdentifier] = useState("");
  useEffect(()=>{
    const tenantLocalData = localStorage.getItem('tenantInfo');
    const tenantLocalDataParse = JSON.parse(tenantLocalData);
    setSuperAdmin(tenantLocalDataParse?.identifier);
    setIdentifier(tenantLocalDataParse?.code);
  },[superAdmin])

  

  const NotFoundRedirect = () => {
    const navigate = useNavigate();
    useEffect(() => {
      // Redirect to the desired path with the state
      navigate('/');
    }, [navigate]);
  };

  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/forget-password" element={<ForgetPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/contactUs" element={<ContactUs />} />
       

        {
          superAdmin === "default"?
          <Route element={<SuperAdminLayout />}>
            <Route path="/" element={<UserManagement />} />
            <Route path="/user-management" element={<UserManagement />} />
            <Route path="/tenant-onboarding" element={<TenantOnboarding />} />
            <Route path="/user-add" element={<UserAdd />} />
            <Route path="/add-super-tenant" element={<SuperTenantAdd />} />
            <Route path="/add-tenant" element={<TenantAdd />} />
            <Route path="*" element={<NotFoundRedirect />} />
            <Route path="/audit-logs" element={<AuditLogs />} />
          </Route>
          :
          <Route element={<CmsLayout />}>
            :

{/* <Route element={<GridMoitorView />}>   */}
            {
              identifier === "pktflm" || identifier === "nhstdz" ?
              ''
              :
              <Route  path="/store-front"  element={<PrivateRoute><StoreFront /></PrivateRoute>} />
            }


{/* <Route element={<GridMoitorView />}/>  */}
            <Route path="/" element={<Viewership />} />
            <Route path="/viewership" element={<Viewership />} />
            <Route path="/scheduling" element={<Scheduling />} />
            {/* <Route path="/playlists" element={<PlaylistsMain/>} /> */}
            {/* <Route path="/schedulingDetail" element={<ScheduleDetail />} /> */}
            <Route path="/scheduling-linear" element={<SchedulingLinear />} />
            <Route path="/linear-expand-view" element={<LinearExpandView />} />
            {/* <Route path="/schedulingLoop" element={<ScheduleLoop />} /> */}
            <Route path="/schedule-Loop" element={<SchedulingLoopNew />} />
            <Route path="/asset" element={<AssetManagement />} />
            <Route path="/cmsChannelDetail" element={<CmsChannelDetail />} />
            <Route path="/monitor" element={<Monitor />} />
            {/* <Route path="/monitorgridview" element={<MonitorGridView />} /> */}
            {/* <Route path="/gridMonitor" element={<GridMonitor />}/> */}
            {/* <Route path="/distribution-platforms" element={<DistributionPlatform />} />
            <Route path="/platform-distribution/:platformId?" element={<AddDistributionPlatform />} /> */}
           
            <Route
              path="/channel-actions"
              element={<Channelactionscomponent />}
            />
            <Route path="/channel" element={<ChannelSetupNew />} />
            <Route path="/channelDetails" element={<ChannelDetails />} />
            <Route path="/channelCreation" element={<ChannelCreation />} />
            <Route path="/addDistributionPlatform" element={<AddDistributionPlatform/>} />
            <Route path="/master-settings" element={<MasterSettings />} />
            <Route path="/meta-edit" element={<EditableGrid />} />
            <Route path="/distribution-platforms" element={<DistributionPlatform />} />
            <Route path="/platform-distribution/:platformId?" element={<AddDistributionPlatform />} />
            <Route path="/platform-distribution/:platformId" element={<DistributionChildTable />} />
            <Route path="/channel/:channelId" element={<EditChannelPopup />} />
            {/* <Route
  path="/platform-distribution/:platformId/edit-channel/:platformChannelId/:channelId"
  element={<EditChannelPopup />}
/> */}
            {/* <Route path="/edit-channel-popup/:platformChannelId?" element={<EditChannelPopup />} /> */}
            {/* <Route path="/store-front" element={<StoreFront />} /> */}

            {/* <Route path="/store-front" element={<StoreFront />} /> */}
            
            <Route path="/add-super-tenant" element={<SuperTenantAdd />} />
            <Route path="/add-tenant" element={<TenantAdd />} />
            
            <Route path="/user-add" element={<UserAdd />} />
            {/* Add other nested routes for the "CmsLayout" here */}
            <Route path="*" element={<NotFoundRedirect />} />
          </Route>
          
                  // </Route>

        }

<Route element={<GridMonitorView />}>
<Route path="/gridMonitor" element={<GridMonitor />}/> 
</Route>


        {/* <Route exact path="/login" component={LoginComponent} />
    {/* Define other routes here */}
        {/* <Route path="/viewership" component={ViewershipComponent} />
      <Route path="/dashbord" component={DashboardComponent} />
      <Route path="/dashbord-channel" component={DashbordChannelComponent} />
      <Route path="/channel-actions" component={ChannelActionsComponent} />
      <Route path="/scheduling" component={SchedulingComponent} />
      <Route path="/channel-setup" component={ChannelSetupComponent} />
      <Route path="/channel-creation" component={ChannelCreationComponent} />
      <Route path="/channel-upload" component={ChannelUploadComponent} /> */}

      </Routes>
    </Router>
  );
}

export default AppRoutes;
